module.exports = __webpack_public_path__ + "img/F75701DD.f19b8a8e.png";